<template>
<b-card no-body >
  <b-card-header  header-tag="header" class="p-1" role="tab">
    <b-button v-if="iso639_1 === 'es'" block href="#" v-b-toggle.accordion-2 variant="info">Habitación n-{{numeroh}}</b-button>
    <b-button v-else block href="#" v-b-toggle.accordion-2 variant="info">Room n-{{numeroh}}</b-button>
  </b-card-header>
  <b-collapse visible id="accordion-2" accordion="my-accordion" role="tabpanel">
    <b-card-body class="mb-4 mt-4">
        <b-container fluid style="font-weight: bold;">
          <b-row>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row class="row-card-room">
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room ">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/cama-2-plazas.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Cama 2 plazas    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px;">
                           Two seater bed   
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad cama menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcama2p">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col> 
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.cama2p"> 
                            </b-col>

                            <!-- Controles de cantidad cama mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.cama2p++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col> 
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row class="row-card-room">
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/bano-ducha.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Baño compartido   
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                           Shared bathroom  
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad baño compartido menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarbcompartido">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.bcompartido">
                            </b-col>
                            <!-- Controles de cantidad baño compartido mas -->
                             <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.bcompartido++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body  class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/camam.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Cama 1 1/2 plaza
                        </b-card-text>
                        <b-card-text class="text-center" v-else style="margin-left:-10px; position:absolute; top:60px;  font-weight: bold;">
                           One and a half square bed 
                        </b-card-text>  
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">

                            <!-- Controles de cantidad cama 1 1/2 menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcamam">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.camam">
                            </b-col>

                            <!-- Controles de cantidad cama 1 1/2 mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.camam++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>

                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/cama1p.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Cama 1 plaza
                        </b-card-text>
                        <b-card-text v-else style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                           Single bed 
                        </b-card-text>    
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad cama 1 plaza menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcama1p">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.cama1p">
                            </b-col>
                            
                            <!-- Controles de cantidad cama 1 plaza mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.cama1p++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body  class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/medio-bano.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:30px; position:absolute; top:60px;  font-weight: bold;">
                            Baño privado    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                           Private bathroom 
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad baño privado menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarbprivado">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.bprivado">
                            </b-col>

                            <!-- Controles de cantidad baño privado mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.bprivado++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/camarote.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                            Camarote    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:60px; position:absolute; top:60px;  font-weight: bold;">
                           Cabin
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad camarote menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcamarote">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.camarote">
                            </b-col>
                            <!-- Controles de cantidad camarote mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.camarote++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/velador.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                            Velador    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                           Pedestal table
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad velador menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarvelador">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.velador">
                            </b-col>
                            <!-- Controles de cantidad velador mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.velador++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col> 
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/scama.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                            Sofá cama      
                        </b-card-text>
                        <b-card-text v-else style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                           Settee-bed
                        </b-card-text>    
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad sofa cama menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarscama">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.scama">
                            </b-col>

                            <!-- Controles de cantidad sofa cama mas -->
                             <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.scama++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/closet.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:55px; position:absolute; top:60px;  font-weight: bold;">
                            Clóset     
                        </b-card-text>
                        <b-card-text v-else style="margin-left:55px; position:absolute; top:60px;  font-weight: bold;">
                           Closet
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad closet menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcloset">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>                             

                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.closet">
                            </b-col>

                            <!-- Controles de cantidad closet mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.closet++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/escritorio.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Escritorio con silla    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                           Desk with chair
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad escritorio c/ silla menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validaresilla">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.esilla">
                            </b-col>
                            <!-- Controles de cantidad escritorio c/ silla mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.esilla++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/acondicionado.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Aire acondicionado  
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                           Air conditioner
                        </b-card-text>  
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Aire Acondicionado menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validaracondicionado">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>

                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.acondicionado">
                            </b-col>

                            <!-- Controles de cantidad Aire Acondicionado mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.acondicionado++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>  
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col> 
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/rcama.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Ropa de cama    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                            Linens
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Ropa de Cama menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarrcama">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>                          

                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.rcama">
                            </b-col>

                            <!-- Controles de cantidad Ropa de Cama mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.rcama++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>
                             
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/calefaccion.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Calefacción    
                        </b-card-text>
                        <b-card-text v-else style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                            Heating
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Calefacion menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcalefaccion">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.calefaccion">
                            </b-col>

                            <!-- Controles de cantidad Calefacion mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.calefaccion++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col>

                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col> 
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/wifi.svg">      
                        </b-card-text>
                        <b-card-text style="margin-left:65px; position:absolute; top:60px;  font-weight: bold;">
                            Wifi  
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Wifi menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarwifi">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.wifi">
                            </b-col>

                            <!-- Controles de cantidad Wifi mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.wifi++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/spelo.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                             Secador de pelo   
                        </b-card-text>
                        <b-card-text v-else style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                            Hair dryer
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Secador menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarsecador">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.secador">
                            </b-col>
                            <!-- Controles de cantidad Secador mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.secador++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col> 
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/tv.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                             Televisión  
                        </b-card-text>
                        <b-card-text v-else style="margin-left:70px; position:absolute; top:60px;  font-weight: bold;">
                            TV
                        </b-card-text>  
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Television menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validartv">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.tv">
                            </b-col>
                            <!-- Controles de cantidad Television mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.tv++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body class="card-body-room">
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/colgador.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                             Colgadores  
                        </b-card-text>
                        <b-card-text v-else style="margin-left:45px; position:absolute; top:60px;  font-weight: bold;">
                            Hangers
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Colgadores menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarcolgadores">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.colgadores">
                            </b-col>
                            <!-- Controles de cantidad Colgadores mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.colgadores++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3 mb-4 mt-4" class="col-card-room">
              <b-row>
                <b-col cols="12" md="12" sm="8">
                    <b-card-body >
                        <b-card-text style="margin-left:60px;">
                            <img width="40px" src="../assets/fan.svg">      
                        </b-card-text>
                        <b-card-text v-if="iso639_1 === 'es'" style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                             Ventilador  
                        </b-card-text>
                        <b-card-text v-else style="margin-left:65px;">
                            Fan
                        </b-card-text>   
                        <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                        <b-row style="margin-left:-30px;">
                            <!-- Controles de cantidad Ventiladores menos -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="validarventilador">
                                    <img width="15px" src="../assets/up-arrow.svg">
                                </button>
                            </b-col>
                                                
                            <b-col cols="4">
                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="pieza.ventilador">
                            </b-col>
                            <!-- Controles de cantidad Ventiladores mas -->
                            <b-col cols="4">
                                <button  style="width:40px; border:none; background-color:white;" type="button" @click="pieza.ventilador++">
                                    <img width="15px" src="../assets/down-arrow.svg">
                                </button>
                            </b-col> 
                        </b-row>                       
                        </b-card-text>                                                        
                    </b-card-body>
                </b-col>
              </b-row>
            </b-col>                                                                                                                                                                                                                                                                         
          </b-row>
        </b-container>
        </b-card-body>
      </b-collapse>
    </b-card>


</template>

<script>

  export default {
    name: 'Room',
    props: ['numeroh', 'iso639_1'],
    data() {
        return {
            pieza:{
                idpieza: 0,
                cama2p: 0,
                bcompartido: 0,
                camam: 0,
                cama1p: 0,
                bprivado: 0,
                camarote: 0,
                velador: 0,
                scama: 0,
                closet: 0,
                esilla: 0,
                acondicionado: 0,
                rcama: 0,
                calefaccion: 0,
                wifi: 0,
                secador: 0,
                tv: 0,
                colgadores: 0,
                ventilador: 0,
            }    
        }
    },
    methods:{
        validarcama2p(){
            if(!this.pieza.cama2p <= 0){
               this.pieza.cama2p--
            }
        },
        validarbcompartido(){
            if(!this.pieza.bcompartido <= 0){
               this.pieza.bcompartido--
            }
        },
        validarcamam(){
            if(!this.pieza.camam <= 0){
               this.pieza.camam--
            }
        },
        validarcama1p(){
            if(!this.pieza.cama1p <= 0){
               this.pieza.cama1p--
            }
        },
        validarbprivado(){
            if(!this.pieza.bprivado <= 0){
               this.pieza.bprivado--
            }
        }, 
        validarcamarote(){
            if(!this.pieza.camarote <= 0){
               this.pieza.camarote--
            }
        },                   
        validarvelador(){
            if(!this.pieza.velador <= 0){
               this.pieza.velador--
            }
        },
        validarscama(){
            if(!this.pieza.scama <= 0){
               this.pieza.scama--
            }
        }, 
        validarcloset(){
            if(!this.pieza.closet <= 0){
               this.pieza.closet--
            }
        },
        validaresilla(){
            if(!this.pieza.esilla <= 0){
               this.pieza.esilla--
            }
        },          
        validaracondicionado(){
            if(!this.pieza.acondicionado <= 0){
               this.pieza.acondicionado--
            }
        },        
        validarrcama(){
            if(!this.pieza.rcama <= 0){
               this.pieza.rcama--
            }
        },
        validarcalefaccion(){
            if(!this.pieza.calefaccion <= 0){
               this.pieza.calefaccion--
            }
        }, 
        validarwifi(){
            if(!this.pieza.wifi <= 0){
               this.pieza.wifi--
            }
        },
        validarsecador(){
            if(!this.pieza.secador <= 0){
               this.pieza.secador--
            }
        },
        validartv(){
            if(!this.pieza.tv <= 0){
               this.pieza.tv--
            }
        },
        validarcolgadores(){
            if(!this.pieza.colgadores <= 0){
               this.pieza.colgadores--
            }
        },
        validarventilador(){
            if(!this.pieza.ventilador <= 0){
               this.pieza.ventilador--
            }
        },                                                         
    }
}
</script>

<style>
.btn.btn-info.btn-block{
background-color: #5A287F;
}
.btn.btn-info.btn-block.collapsed{
background-color:#5A287F;
}


input {
  text-align:center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
